/**
 * V2QsSelectCountry 컴포넌트 Props 인터페이스
 * V1 QsInputSelectCountry의 V2 버전 (순수 UI만)
 *
 * 국가 선택을 위한 드롭다운 컴포넌트
 */

/**
 * 국가 옵션 아이템
 */
export interface V2QsCountryOption {
  /**
   * 국가 코드 (예: 'US', 'KR')
   */
  value: string;

  /**
   * 표시할 국가명
   */
  label: string;
}

export interface V2QsSelectCountryProps {
  /**
   * 국가 옵션 목록
   */
  options: V2QsCountryOption[];

  /**
   * 선택된 값 (단일 선택 시 문자열, 다중 선택 시 배열)
   */
  value?: string | string[];

  /**
   * 값 변경 시 콜백
   */
  onChange?: (value: string | string[]) => void;

  /**
   * 다중 선택 모드
   */
  multi?: boolean;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;

  /**
   * 읽기 전용 여부
   */
  readOnly?: boolean;

  /**
   * 에러 상태
   */
  hasError?: boolean;

  /**
   * 에러 메시지
   */
  errorMessage?: string;

  /**
   * 플레이스홀더 텍스트
   */
  placeholder?: string;

  /**
   * 추가 CSS 클래스
   */
  className?: string;

  /**
   * Select 요소 추가 CSS 클래스
   */
  selectClassName?: string;

  /**
   * 자동 포커스
   */
  autoFocus?: boolean;
}

export const defaultV2QsSelectCountryProps: Partial<V2QsSelectCountryProps> = {
  multi: false,
  disabled: false,
  readOnly: false,
  hasError: false,
  placeholder: '--',
};
